namespace RedBullMOBILE360.LoanWhitelist {
    export namespace LoanWhitelistService {
        export const baseUrl = 'LoanWhitelist/LoanWhitelist';

        export declare function Create(request: Serenity.SaveRequest<LoanWhitelistRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<LoanWhitelistRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<LoanWhitelistRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<LoanWhitelistRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ExcelImport(request: Serenity.Extensions.ExcelImportRequest, onSuccess?: (response: Serenity.Extensions.ExcelImportResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "LoanWhitelist/LoanWhitelist/Create",
            Update = "LoanWhitelist/LoanWhitelist/Update",
            Delete = "LoanWhitelist/LoanWhitelist/Delete",
            Retrieve = "LoanWhitelist/LoanWhitelist/Retrieve",
            List = "LoanWhitelist/LoanWhitelist/List",
            ExcelImport = "LoanWhitelist/LoanWhitelist/ExcelImport"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'ExcelImport'
        ].forEach(x => {
            (<any>LoanWhitelistService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
